import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9ys7k5bec7: FaireBrandEntity = {
  token: "b_9ys7k5bec7",
  type: "brand",
  name: "Cabi",
  avatarUrl:
    "https://cdn.faire.com/fastly/02768fbd5e5ba3787f8bbd683a2af62ce49d7adabbf3559e56e52710b125cd6e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5430a03f29129a71e7877b7d4872cb40db187b584b9b0c1e2aef7998c1912c17.png",
  logoUrl:
    "https://cdn.faire.com/fastly/02768fbd5e5ba3787f8bbd683a2af62ce49d7adabbf3559e56e52710b125cd6e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5430a03f29129a71e7877b7d4872cb40db187b584b9b0c1e2aef7998c1912c17.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 18,
  isTopShop: true,
  isInsider: true,
  description:
    "★★Featured on VOGUE, NY Times, LA Times and TODAY SHOW★★\nEasily elevate your cooking with Cabi Trio: easy-to-use Japanese flavors. It’s all you need. No cooking required, unless desired.\n\nCabi started because we wanted to share the beauty and ease of Japanese home cooking.\nWe believe that food is a universal language that shows love and it can be shared with multiple cultures yet unique to its own origin. Cabi is unique to Japan, but as the world gets smaller and smaller we have created our unique and original flavors to share our culture that can be used in any type of cuisine in the way we think is love and authentic. We believe everyone should eat healthier and better food with peace of mind. That’s why we commit to quality and flavors creating the original products with partners in Japan who have been perfecting their products for over 100+ years.\n\nWe’ve all done it before, you want to try a new recipe and end up buying 10 bottles of new condiments you’ve never heard of that sit in the cupboard after that one dish is made. Cabi condiments are carefully created so that they don’t just sit in your cupboard. They are formulated with foundational flavors and profiles that make up the backbone for many essential Japanese flavors you’ve experienced, making it perfect not just for Japanese dishes, but for anything your way and beyond.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:26.075Z",
    importedBy: "entity-db-cli",
  },
};
